import React from "react";
import { SubjectsOverviewContainer } from "./SubjectsOverview.style";

import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Subject Images
import CivicsLogo from "Assets/Images/Subjects/civics_logo.png";
import ForeignLanguageLogo from "Assets/Images/Subjects/foreignlanguage_logo.png";
import EnglishLogo from "Assets/Images/Subjects/english_logo.png";
import EconomicsLogo from "Assets/Images/Subjects/economics_logo.png";
import HistoryLogo from "Assets/Images/Subjects/history_logo.png";
import MathLogo from "Assets/Images/Subjects/math_logo.png";
import ScienceLogo from "Assets/Images/Subjects/science_logo.png";

import ScienceBackground from "Assets/Images/SubjectsDashboard/Science.png";
import MathBackground from "Assets/Images/SubjectsDashboard/Math.png";
import ForeignLanguageBackground from "Assets/Images/SubjectsDashboard/FL.png";
import EnglishBackground from "Assets/Images/SubjectsDashboard/English.png";
import HistoryBackground from "Assets/Images/SubjectsDashboard/History.png";
import EconomicsBackground from "Assets/Images/SubjectsDashboard/Economics.png";
import CivicsBackground from "Assets/Images/SubjectsDashboard/CivicImage.png";

// Civic card images
import C1 from "Assets/Images/SubjectsDashboard/C1.svg";
import C2 from "Assets/Images/SubjectsDashboard/C2.svg";
import C3 from "Assets/Images/SubjectsDashboard/C3.svg";
import C4 from "Assets/Images/SubjectsDashboard/C4.svg";
import C5 from "Assets/Images/SubjectsDashboard/C5.svg";
import C6 from "Assets/Images/SubjectsDashboard/C6.svg";

// Other subject card images
import Connect from "Assets/Images/SubjectsDashboard/Connect.svg";
import Crossword from "Assets/Images/SubjectsDashboard/Crossword.svg";
import Cubs from "Assets/Images/SubjectsDashboard/Cubs.svg";
import LooseLink from "Assets/Images/SubjectsDashboard/LooseLink.svg";
import PresentorPast from "Assets/Images/SubjectsDashboard/PresentorPast.svg";
import Pursuit from "Assets/Images/SubjectsDashboard/Pursuit.svg";
import Quiz from "Assets/Images/SubjectsDashboard/Quiz.svg";
import RapidFire from "Assets/Images/SubjectsDashboard/RapidFire.svg";
import Table from "Assets/Images/SubjectsDashboard/Table.svg";

// Subject data with descriptions
const subjectsData = [
	{
		subject: "Civics",
		LogoImage: CivicsLogo,
		backgroundImage: CivicsBackground,
		description: (
			<>
				Civics Master wants to encourage everyone to get involved in learning about government and most importantly have the basic understanding of how government works for the American
				people. Being informed is the most effective way for a <span className="red-text">VOTER</span> to make its voice heard, a <span className="red-text">MAYOR</span> to effectively enhance
				its community, a <span className="red-text">GOVERNOR</span> to enable growth within its state, a <span className="red-text">REPRESENTATIVE</span> and/or{" "}
				<span className="red-text">SENATOR</span> to ensure its constituent's rights are upheld or a <span className="red-text">PRESIDENT</span> to protect Americans from undue burden. Civics
				Master is looking forward to its users developing a sustainable appetite for government, motivating its users to get involved in the process while remaining optimistic it will inspire
				action.
			</>
		),
		cards: [
			{
				title: "Legislative Knowledge Test",
				description:
					"Test your students knowledge of the Legislative Branch by providing 26 questions that you've addressed with in-class instruction. The leaderboard will show who's standing out in your class.  ",
				image: C1,
			},
			{
				title: "Escape Room Challenge",
				description: "Students will need to challenge themselves and think outside the box in order to complete this escape room! Does your students have what it takes?",
				image: C2,
			},
			{
				title: "Spin Around the Courts",
				description: "Have your students take a spin around the courts. They will earn spins by answering the Judicial questions you provide and then they will press their luck on the board.",
				image: C3,
			},
			{
				title: "Constitution Quiz",
				description: "How well does our students know the constitution? This game will test their knowledge in a rapid fire way.",
				image: C4,
			},
			{
				title: "Legislative Quiz Game",
				description: "This quiz game will challenge your students in each category of the  Legislative Branch. This is a great game to test the overall Legislative knowledge of your students",
				image: C5,
			},
			{
				title: "Final Stage",
				description:
					"The final stage of the Civics module. A cumulative assessment of the Legislative branch. Can your students pass this final game which again is based on the questions you the educator provides?",
				image: C6,
			},
		],
	},
	{
		subject: "Science",
		LogoImage: ScienceLogo,
		backgroundImage: ScienceBackground,
		description:
			"Science Master seeks to invigorate science to show how science impacts us on a day to day basis. Student involvement in studying living things, whether it’s the earth’s make-up, fundamental units of life or identifying substances, is vital to science growth. Appealing to the students curiosity by encouraging objective observation and experimentation will create an exciting atmosphere of learning and can strengthen the students will to master this subject.",
		cards: [
			{
				title: "Leaderboard Challenge",
				description: "How well does your students know Science? This game will test their knowledge of any Science questions the educator enters in a rapid fire way.",
				image: RapidFire,
			},
			{
				title: "Rapid Fire Quiz",
				description: "This interactive periodic table provides a fun and exciting way for students to learn and retain all the elements of the periodic table. Check it out.",
				image: Table,
			},
			{
				title: "Final Assessment",
				description: "Assign six (6) students to play this engaging Loose Link game in class or outside of class and let's find out who will be standing in the end.",
				image: LooseLink,
			},
		],
	},
	{
		subject: "Math",
		LogoImage: MathLogo,
		backgroundImage: MathBackground,
		description:
			"Math Master strives to help students overcome their fear of numbers and concepts. Studying numbers interrelation, measurements, combinations, and operations can be a challenge for some. We try to ease the anxiety some may feel by providing a themed way of learning these concepts through gaming. We seek to inspire students to embrace the challenge by making it enjoyable to learn and as simple as possible to understand.",
		cards: [
			{
				title: "Calculation Challenge",
				description: "Connect 4 can be played with another student in the same class or the computer. Test your students math knowledge in a fun and competitive way.",
				image: Connect,
			},
			{
				title: "Puzzle Challenge",
				description:
					"Students try their luck at rolling a MATHAHTZEE! If they can answer your tough math questions correctly. This game can be played with another student or against the computer.",
				image: Cubs,
			},
		],
	},
	{
		subject: "Foreign Language",
		LogoImage: ForeignLanguageLogo,
		backgroundImage: ForeignLanguageBackground,
		description:
			"Foreign Language Master encourages the study of multiple languages. Being able to communicate with a variety of cultures will only enhance a student’s ability to become a dynamic voice in the conversation. As our world continues to become more interdependent, the ability to speak a language that is not widely spoken in the country you reside, will enhance the students understanding of their own culture, provide a competitive edge and create a confidence that will endure.",
		cards: [
			{
				title: "Vocabulary Builder",
				description:
					"How well does your students know the foreign language you are currently teaching. Whether it’s Spanish, French, Italian or Mandarin? This game will test their knowledge in a rapid fire way.",
				image: RapidFire,
			},
			{
				title: "Grammar Challenge",
				description:
					"This quiz game will challenge your students in each category of the Foreign language you are teaching. This is a great game to test the students overall knowledge of the nouns, verbs, numbers, letters, colors and/or greeting.",
				image: Quiz,
			},
		],
	},
	{
		subject: "English",
		LogoImage: EnglishLogo,
		backgroundImage: EnglishBackground,
		description:
			"English Master understands the importance of an extensive vocabulary and how it benefits an individual’s comprehension and his/her oral and written communication. Broad reading delivers thoughtful evaluation, promotes critical thinking and compels understanding. An extensive vocabulary drives high quality communication and a great communicator acknowledges the need to read.",
		cards: [
			{
				title: "Vocabulary Builder",
				description: "How well has your students memorized the definitions for their vocabulary words? This game will test their knowledge in a rapid fire way.",
				image: RapidFire,
			},
			{
				title: "Grammar Challenge",
				description: "Have your students solve the crossword puzzle using words that you the educator has provided definitions for. This game can be challenging.",
				image: Crossword,
			},
		],
	},
	{
		subject: "History",
		LogoImage: HistoryLogo,
		backgroundImage: HistoryBackground,
		description:
			"History Master wants to revitalize the historical reference of American history in such a way, that it will dispel censuring, by demanding sensibility and recognition of our history no matter how obscure. The teaching of history provides the knowledge of how we started, assess the events of how we’ve changed and foster collaboration on how we move forward as a society, in the hopes that understanding our past will guide our future.",
		cards: [
			{
				title: "Vocabulary Builder",
				description: "Make History fun to learn with this rapid fire way of learning? Test how well your students has retained the knowledge of History taught in your class.",
				image: RapidFire,
			},
			{
				title: "Grammar Challenge",
				description:
					"Evaluate your students' knowledge of history by providing 26 questions that you have covered during in-class instruction. The leaderboard will display the top performers in your class",
				image: PresentorPast,
			},
		],
	},
	{
		subject: "Economics",
		LogoImage: EconomicsLogo,
		backgroundImage: EconomicsBackground,
		description:
			"Economics Master is here to prepare students during their transition to becoming young adults, by providing the economic knowledge of how to employ scarce resources, manage finances as it relates to budgeting, investing and savings via macroeconomics. Supply, demand and market price via microeconomics. Fiscal policies as it relates to tax and spend and introducing them to the global economy as it also effects our choices. Presenting these topics in the most stimulating way will allow students to own their financial destiny.",
		cards: [
			{
				title: "Vocabulary Builder",
				description: "How well has your students retained the Economics of today? This game will test their knowledge in a rapid fire way.",
				image: RapidFire,
			},
			{
				title: "Grammar Challenge",
				description:
					"Round 1 gather as many points as possible. Round 2 attempt to Out last the Pursuit. Round 3 earn your points. This three (3) stage game can be challenging but motivating.",
				image: Pursuit,
			},
		],
	},
];

const SubjectsOverview = () => {

	const location = useLocation();

	useEffect(() => {
		if (location.hash) {
			const element = document.getElementById(location.hash.substring(1)); // remove the #
			if (element) {
				element.scrollIntoView({ behavior: "smooth" });
			}
		}
	}, [location]);

	return (
		<SubjectsOverviewContainer>
			<div className="subjects_overview_sections">
				<div className="mygrid-container">
					<div className="mygrid-row">
						<div className="mygrid-col-md-12">
							<div className="subjects_list">
								{subjectsData.map((subject, index) => (
									<div key={index} id={subject.subject.toLowerCase().replace(/\s+/g, "-")} className="subject_item_wrapper">
										<div className={`subject_item ${index % 2 === 0 ? "even" : "odd"}`}>
											{index % 2 === 0 ? (
												<>
													<div className="subject_image_section">
														<img src={subject.backgroundImage} alt={subject.subject} />
													</div>
													<div className="subject_description_section">
														<div className="subject_title_row">
															<h3 className="subject_title">{subject.subject}</h3>
															<img src={subject.LogoImage} alt={subject.subject} className="subject_logo" />
														</div>
														<p className="subject_description">{subject.description}</p>
													</div>
												</>
											) : (
												<>
													<div className="subject_description_section">
														<div className="subject_title_row">
															<h3 className="subject_title">{subject.subject}</h3>
															<img src={subject.LogoImage} alt={subject.subject} className="subject_logo" />
														</div>
														<p className="subject_description">{subject.description}</p>
													</div>
													<div className="subject_image_section">
														<img src={subject.backgroundImage} alt={subject.subject} />
													</div>
												</>
											)}
										</div>
										<div className={`subject_cards_section ${subject.cards.length === 2 ? "two-cards" : "three-cards"}`}>
											{subject.cards.map((card, cardIndex) => (
												<div key={cardIndex} className="subject_card">
													<div className="card_icon">
														<img src={card.image} alt={card.title} />
													</div>
													<div className="card_content">
														<p className="card_description">{card.description}</p>
													</div>
												</div>
											))}
										</div>
									</div>
								))}
							</div>
						</div>
					</div>
				</div>
			</div>
		</SubjectsOverviewContainer>
	);
};

export default SubjectsOverview;
